export const LIST_RECIPIENTS_DEFAULT_PAGE_SIZE = 25;
export const LIST_RECIPIENTS_MAX_PAGE_SIZE = 100;
export const METL_LIST_RECIPIENTS_PAGE_SIZE = 5000;
